module.exports = __webpack_public_path__ + "static/img/guide2.a39ac6c0.png";